<template>
    <section class="search-results-item results-item">
        <div class="results-item__wrapper">
            <div class="results-item__category">
                <template v-if="item.breadcrumbs && item.breadcrumbs[0]">
                    <template v-if="item.breadcrumbs[0].url">
                        <router-link
                            :to="{
                                name: item.breadcrumbs[0].title,
                                params: { type: item.breadcrumbs[0].type, id: item.breadcrumbs[0]._id, slug: getSlug(item.breadcrumbs[0].url)},
                            }"
                            class="results-item__category-title"
                        >
                            {{ item.breadcrumbs[0].title }}
                        </router-link>
                        <!-- <router-link :to="item.breadcrumbs[0].url" class="results-item__category-title">{{ item.breadcrumbs[0].title }}</router-link> -->
                    </template>
                    <template v-else>
                        <span class="results-item__category-title">{{ item.breadcrumbs[0].title }}</span>
                    </template>
                </template>
            </div>

            <template v-if="item.type === 'GAME'">
                <div class="results-item__link" @click.prevent.stop="toggleModalGame">
                    <figure class="results-item__img" :style="{'border-color': color}">
                        <Image :image="item.image" :width="324" :height="182" :isLazy="false"></Image>
                    </figure>

                    <h4 class="results-item__title" v-html="item.title" ></h4>
                </div>
            </template>

            <template v-else>
                <router-link
                    :to="{
                        name: item.type.charAt(0).toUpperCase() + item.type.slice(1).toLowerCase(),
                        params: { type: item.type, id: item._id, slug: getSlug(item.url)},
                    }"
                        class="results-item__link"
                    >
                    <figure class="results-item__img" :style="{'border-color': color}">
                        <Image :image="item.image" :width="324" :height="182" :isLazy="false"></Image>
                    </figure>

                    <h4 class="results-item__title" v-html="item.title" ></h4>
                </router-link>
            </template>
        </div>

        <transition name="fade" appear>
            <ModalIframe
                v-if="item.type === 'GAME' && isModalGame"
                :url="item.url"
            ></ModalIframe>
        </transition>
    </section>
</template>

<script>
import Image from "../elements/Image.vue";
import ModalIframe from "../modals/ModalIframe.vue";

export default {
    name: "SearchResultsItem",
    components: {
        Image,
        ModalIframe
    },
    props: {
        item: {
            type: Object,
            default: () => {},
        }
    },
    data() {
        return {
            isModalGame: false
        };
    },
    computed: {
        color() {
            if(this.item.breadcrumbs && this.item.breadcrumbs[0] && this.item.breadcrumbs[0].color) {
                return this.item.breadcrumbs[0].color;
            }
            return null;
        }
    },
    methods: {
        getSlug(url) {
            return url.substring(url.lastIndexOf("/") + 1) 
        },
        toggleModalGame() {
            this.isModalGame = !this.isModalGame;
        }
    }
};
</script>
